import {
  Component,
  EventEmitter,
  Injector,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { HEADER_NAVIGATION } from "src/app/shared/global/constants";
import { UserDetailsService } from "src/app/shared/services/user-details.service";
import { UtilsService } from "src/app/shared/services/utils-service/utils.service";
import { ThemeService } from "../theme/theme.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { GuideModelComponent } from "src/app/shared/components/guide-model/guide-model.component";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TasksService } from "src/app/shared/services/task-service/tasks.service";
import { NotificationService } from "src/app/shared/services/notification/notification.service";
import { MatMenuTrigger } from "@angular/material/menu";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/shared/services/auth-service/auth.service";
import { LocalStorageService } from "src/app/shared/services/storage-service/local-storage.service";
import { SubscriptionPlanService } from "src/app/shared/services/subscription-service/subscription-plan.service";
@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  providers: [DatePipe],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public utils: UtilsService;
  headerNav: any;
  user: any;
  userImgPath: any = "";
  unreadNotificationCount: any;
  private dialogRef: MatDialogRef<GuideModelComponent>;
  subscription: Subscription;
  @ViewChild(MatMenuTrigger) notification: MatMenuTrigger;
  isShowNotificationList = false;
  isToggled = false;
  showAnnouncement: any = false;
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();
  public userDetail: UserDetailsService;
  private taskService: TasksService;
  private notificationService: NotificationService;
  activeTheme:boolean = false;
  private subscriptionPlanService: SubscriptionPlanService;
  private subscriptionPlanSubscription?: Subscription;
  subscriptionExpiryLabel = "";
  subscriptionCountdownLabel = "";
  showSubscriptionReminder = false;
  subscriptionExpired = false;

  //   async readAnnouncement() {
  //       const current_date_time = moment(new Date()).valueOf();
  //       (await this.taskService.readAnnouncement(current_date_time)).subscribe(
  //           async (res: any) => {
  //               if (res && res.result) {
  //                   this.showAnnouncement = true;
  //               }
  //           }
  //       );
  //   }

  constructor(
    private themeService: ThemeService,
    private injector: Injector,
    private translate: TranslateService,
    private router: Router,
    private matDialog: MatDialog,
    public authService: AuthService,
    public localStorage: LocalStorageService,
    private datePipe: DatePipe
  ) {
    this.userDetail = injector.get<UserDetailsService>(UserDetailsService);
    this.taskService = injector.get<TasksService>(TasksService);
    this.notificationService =
      injector.get<NotificationService>(NotificationService);
    this.subscriptionPlanService = injector.get<SubscriptionPlanService>(
      SubscriptionPlanService
    );
    this.headerNav = [HEADER_NAVIGATION];
    this.utils = injector.get<UtilsService>(UtilsService);
    translate.setDefaultLang("en");
  }

  async ngOnInit() {
    this.activeTheme = (await this.localStorage.getLocalStore('theme') == 'dark') ? true : false;
    this.user = await this.userDetail.getUserName();
    this.subscription = await this.userDetail.updateUserImg.subscribe(
      async (_user) => {
        this.userImgPath = (await this.userDetail.getUserImagePath()) || "";
      }
    );
    this.subscription = await this.userDetail.updateUserName.subscribe(
      async (_user) => {
        this.user = await this.userDetail.getUserName();
      }
    );
    this.subscription = this.taskService.openAnnouncement.subscribe((flag) => {
      this.showAnnouncement = flag;
    });
    this.subscription = this.notificationService.addNotification$.subscribe(
      (data: any) => {
        if (data) {
          this.notificationCount();
          this.notification.closeMenu();
        }
      }
    );
    this.notificationCount();
    await this.loadSubscriptionReminder();
  }
  openAnnouncement() {
    this.showAnnouncement = false;
    this.router.navigate(["/dashboard"]);
  }

  async toggle() {
    const active:any = await this.localStorage.getLocalStore('theme');
    if (active === "light") {
      this.localStorage.setLocalStore('theme','dark')
      this.themeService.setTheme("dark");
    } else {
      this.themeService.setTheme("light");
      this.localStorage.setLocalStore('theme','light')
    }
  }

  openGuideModal() {
    this.dialogRef = this.matDialog.open(GuideModelComponent, {
      panelClass: ["custom-modal", "custom-modal-md", "guide-modal"],
    });
    this.dialogRef.afterClosed().subscribe((_res) => {
      // Data back from dialog
    });
  }

  async notificationCount() {
    (await this.notificationService.getNotificationCount()).subscribe(
      (res: any) => {
        this.unreadNotificationCount = res.data?.unread_notification_count;
      }
    );
  }

  redirectToNotificationList() {
    this.router.navigate(["/notification"]);
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this.subscriptionPlanSubscription?.unsubscribe();
  }
  clickToggle() {
    this.isToggled = !this.isToggled;
    this.dataEvent.emit(this.isToggled);
  }

  accountLogout(){
    this.themeService.setTheme("light");
    this.localStorage.setLocalStore('theme','light');
    setTimeout(() => {
      this.authService.logout()
    }, 100);
  }

  private async loadSubscriptionReminder() {
    const cachedPlanSummary = this.subscriptionPlanService.activePlanData;
    if (cachedPlanSummary) {
      this.updateSubscriptionReminder(cachedPlanSummary);
      return;
    }

    try {
      const subscription$ =
        await this.subscriptionPlanService.getSubscriptionDetail(null);
      this.subscriptionPlanSubscription = subscription$.subscribe(
        (resData: any) => {
          const planSummary = resData?.[0];
          this.updateSubscriptionReminder(planSummary);
        }
      );
    } catch (_error) {
      this.resetSubscriptionReminder();
    }
  }

  private updateSubscriptionReminder(planSummary: any) {
    const activePlan = planSummary?.userActivePlanData;
    const expireValue = activePlan?.expire_date;

    if (!expireValue) {
      this.resetSubscriptionReminder();
      return;
    }

    const expiryEpoch = parseInt(expireValue, 10);
    if (Number.isNaN(expiryEpoch)) {
      this.resetSubscriptionReminder();
      return;
    }

    const now = Date.now();
    const diffMs = expiryEpoch - now;
    const formattedDate =
      this.datePipe.transform(expiryEpoch, "d MMM yyyy") || "";
    const daysLeft = Math.max(
      0,
      Math.floor(diffMs / (1000 * 60 * 60 * 24))
    );

    this.subscriptionExpired =
      !!planSummary?.expired || diffMs <= 0;
    this.subscriptionExpiryLabel = formattedDate;
    this.subscriptionCountdownLabel = this.subscriptionExpired
      ? "Expired"
      : `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`;

    const reminderWindowDays = 16;
    const withinReminderWindow =
      daysLeft <= reminderWindowDays || this.subscriptionExpired;

    if (!withinReminderWindow) {
      this.resetSubscriptionReminder();
      return;
    }

    this.showSubscriptionReminder = !!formattedDate;
  }

  private resetSubscriptionReminder() {
    this.subscriptionExpiryLabel = "";
    this.subscriptionCountdownLabel = "";
    this.showSubscriptionReminder = false;
    this.subscriptionExpired = false;
  }
}
